// web/src/components/LogoHeader.tsx
import type { Branding } from "@/theme/branding";

/** Renders the tenant logo above the quiz. Nothing when no logo is set. */
export function LogoHeader({ logo }: { logo?: Branding["logo"] }) {
  if (!logo) return null;
  return (
    <div
      data-quiz-logo
      style={{ padding: "1.25rem 1.5rem 0", display: "flex", justifyContent: "center" }}
    >
      <img
        src={logo.src}
        alt={logo.alt}
        style={{ maxHeight: 48, maxWidth: "60%", objectFit: "contain" }}
      />
    </div>
  );
}
